import { defineStore } from 'pinia';
import { ref } from 'vue';
import { AuthModel } from '@/modules/core/auth/services/AuthService';
import { useLocalStorage } from '@vueuse/core';

export interface AuthStore
{
    loaded: boolean;
    authenticated: boolean;
    identity: AuthModel;
    impersonatedIdentity: AuthModel;
    rememberMe: boolean;
    token: string;
    impersonated: number;
    externalToken: string;
    setLoaded(value: boolean): void;
    setAuthenticated(value: boolean): void;
    setIdentity(model: AuthModel): void;
    setImpersonatedIdentity(model: AuthModel): void;
    clearIdentity(): void;
    clearImpersonatedIdentity(): void;
    setRememberMe(enabled: boolean): void;
    setToken(value: string): void;
    impersonate(id: number): void;
    unimpersonate(): void
    setExternalToken(token: string): void;
}

export const useAuthStore = defineStore('auth', () =>
{
    const loaded = ref<boolean>(false);
    const authenticated = ref<boolean>(false);
    const identity = ref<AuthModel>(null);
    const impersonatedIdentity = ref<AuthModel>(null);
    const rememberMe = ref<boolean>(false);
    const token = useLocalStorage("token", ref<string>(null));
    const impersonated = ref<number>(null);
    const externalToken = ref<string>(null);

    function setLoaded(value: boolean): void
    {
        loaded.value = value;
    }

    function setAuthenticated(value: boolean): void
    {
        authenticated.value = value;
    }

    function setIdentity(model: AuthModel): void
    {
        identity.value = model;
    }

    function setImpersonatedIdentity(model: AuthModel): void
    {
        impersonatedIdentity.value = model;
    }

    function clearIdentity(): void
    {
        identity.value = null;
    }

    function clearImpersonatedIdentity(): void
    {
        impersonatedIdentity.value = null;
    }

    function setRememberMe(enabled: boolean): void
    {
        rememberMe.value = enabled;
    }

    function setToken(value: string): void
    {
        token.value = value;
    }

    function impersonate(id: number): void
    {
        impersonated.value = id;
    }

    function unimpersonate(): void
    {
        impersonated.value = null;
    }

    function setExternalToken(token: string): void
    {
        externalToken.value = token;
    }

    return {
        loaded, authenticated, identity, impersonatedIdentity, rememberMe, token, impersonated, externalToken,
        setLoaded, setAuthenticated, setIdentity, clearIdentity,
        setRememberMe, setToken, impersonate, unimpersonate, setImpersonatedIdentity, clearImpersonatedIdentity, setExternalToken
    };
});
